import { FC, useState, ChangeEvent } from 'react';
import {
  StyledDialog,
  HeaderBox,
  AlertIcon,
  TitleTypography,
  SubtitleTypography,
  SubtitleSecondary,
  ReasonTextArea,
  ButtonContainer,
  RejectButton,
  CancelButton,
  CloseIcon,
  RelativePositionBox,
} from 'src/components/DialogBox/RejectGRNDialog/RejectGRNDialog.styles';

interface RejectGRNDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
}

const RejectGRNDialog: FC<RejectGRNDialogProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const [reason, setReason] = useState('');
  const [touched, setTouched] = useState(false);

  const handleReasonChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setReason(e.target.value);
    setTouched(true);
  };
  const isReasonEmpty = reason.trim().length === 0;

  const handleConfirm = () => {
    if (reason.trim()) {
      onConfirm(reason);
    } else {
      setTouched(true);
    }
  };

  const handleClose = () => {
    setReason('');
    setTouched(false);
    onClose();
  };

  return (
    <StyledDialog open={open} onClose={handleClose}>
      <RelativePositionBox>
        <CloseIcon component="i" className="bx bx-x" onClick={handleClose} />
      </RelativePositionBox>
      <HeaderBox>
        <AlertIcon component="i" className="bx bx-error-circle" />
        <TitleTypography>Reject GRN</TitleTypography>
      </HeaderBox>
      <SubtitleTypography>
        Are you sure you want to reject this GRN?
      </SubtitleTypography>
      <SubtitleSecondary>
        Once rejected, this action cannot be reversed.
      </SubtitleSecondary>
      <ReasonTextArea
        placeholder="Reason for rejection"
        value={reason}
        onChange={handleReasonChange}
        style={{
          borderColor: touched && isReasonEmpty ? 'var(--error)' : undefined,
        }}
      />
      <ButtonContainer>
        <RejectButton onClick={handleConfirm} disabled={isReasonEmpty}>
          Reject
        </RejectButton>
        <CancelButton onClick={handleClose}>Cancel</CancelButton>
      </ButtonContainer>
    </StyledDialog>
  );
};

export default RejectGRNDialog;
